<template>
  <div class="dataset-announcement-content">
    <template v-for="(block, index) in blocks" :key="index">
      <ul v-if="block.type === 'list'" class="announcement-list">
        <li v-for="(item, itemIndex) in block.items" :key="itemIndex"><template v-for="(part, partIndex) in splitBold(item)" :key="partIndex"><b v-if="part.bold">{{ part.text }}</b><template v-else>{{ part.text }}</template></template></li>
      </ul>
      <component :is="block.type === 'heading' ? 'h3' : 'p'" v-else :class="{ 'announcement-section': block.type === 'heading', 'announcement-note': block.type === 'note' }"><template v-for="(part, partIndex) in splitBold(block.text)" :key="partIndex"><b v-if="part.bold">{{ part.text }}</b><template v-else>{{ part.text }}</template></template></component>
    </template>
    <template v-if="!structured && highlights.length">
      <h3>本次更新重点</h3>
      <ul class="announcement-highlights"><li v-for="(point, index) in highlights" :key="index"><span class="el-icon" aria-hidden="true"><CircleCheck /></span><span>{{ point.text }}</span></li></ul>
    </template>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { CircleCheck } from '@element-plus/icons-vue'
import { parseAnnouncementContent, splitBold } from '@/utils/announcementContent'

const props = defineProps({ content: { type: String, default: '' }, highlights: { type: Array, default: () => [] } })
const blocks = computed(() => parseAnnouncementContent(props.content))
const structured = computed(() => blocks.value.some(block => block.type !== 'paragraph'))
</script>
<style scoped>
/* 数据公告的两个阅读入口共用排版；标记只生成 Vue 文本节点，不注入 HTML。 */
.dataset-announcement-content { white-space: normal; color: var(--el-text-color-regular, #606266); font-size: 14px; line-height: 1.8; overflow-wrap: anywhere; }
.dataset-announcement-content p { margin: 0 0 16px; font-size: 14px; line-height: 1.8; white-space: pre-wrap; }
.dataset-announcement-content h3 { margin: 22px 0 12px; font-size: 14px; font-weight: 500; }
.dataset-announcement-content .announcement-section { margin: 20px 0 8px; color: #17233d; font-size: 14px; font-weight: 500; line-height: 22px; }
.announcement-list { margin: 0 0 12px; padding-left: 20px; list-style: disc; }
.announcement-list li { margin: 0 0 6px; padding-left: 2px; color: #17233d; font-size: 14px; line-height: 1.75; overflow-wrap: anywhere; }
.announcement-list li::marker { color: #69778f; }
b { font-weight: 600; color: #17233d; }
.dataset-announcement-content .announcement-note { margin: 4px 0 0; color: #69778f; font-style: italic; }
.announcement-highlights { display: grid; gap: 9px; margin: 0; padding: 0; list-style: none; }
.announcement-highlights li { display: flex; align-items: flex-start; gap: 10px; padding: 9px 10px; border-radius: 9px; background: #f7f9fd; color: #71819c; font-size: 14px; line-height: 1.6; overflow-wrap: anywhere; }
.announcement-highlights li .el-icon { margin-top: 2px; flex-shrink: 0; color: #0840e6; }
</style>
